<app-header></app-header>

<app-new-release-container></app-new-release-container>

<app-get-artist-container></app-get-artist-container> 

<app-recommend-container></app-recommend-container>

<app-favorites-container></app-favorites-container>

<app-footer></app-footer>
